import { day } from './day';
import { time } from './time';

export const unit = {
  day,
  time
};
